import useAxios from 'hooks/useAxios';

export async function setAffiliateCodesToUsers(userIds) {
  const api = useAxios();

  try {
    const res = await api.patch('/users/affiliate-codes/set-users', {
      userIds: userIds,
    });
    return res;
  } catch (err) {
    return err;
  }
}

